import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'timeslot_group_positions': '[TimeslotGroupPositionInputType]',
};

export default gql(`
	mutation timeslot_group_positions( ${ HelperGraphql.createFields( fields ) } ) {
	    timeslot_group_positions( ${ HelperGraphql.createVariables( fields ) } ) {
	       guid
	       position
	    }
	}
`);

